export const pileDefaultValues = {
  hammeringStatus: 'UNATTEMPTED',
};
